<div id="gc-dg-loading" class="gc-dg-centred">
    <p class="gc-dg-font-semibold">Loading...</p>
</div>
